import { Badge, Dropdown } from "react-bootstrap";
import locationIcon from "../../../../Assets/Icons/location-pin.png";
import EditIcon from "../../../../Assets/Icons/icon-edit.png";
import DeleteIcon from "../../../../Assets/Icons/icon-delete.png";

const DeliveryAddressCard = ({
  address = [],
  selectedAddressId,
  handleAddressSelect,
  changeDeliveryAddress,
  handleCloseUpdateModal,
  handleDeleteAddress,
  handleUpdateDefaultAddress,
  showAddressError = false,
  handleShowAddressModal,
  readonly = false,
}) => {
  return (
    <div className="checkOutCard">
      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-start">
            <h4 className="fw-bold pb-4">
              {readonly ? "Delivery Addresses" : "Delivery Address"}
            </h4>
            {!readonly && (
              <button
                className="btn text-danger"
                onClick={handleShowAddressModal}
              >
                + Add address
              </button>
            )}
          </div>

          <div className="deliveryDetails">
            <div className="d-flex locaionDetails">
              <div className="d-flex flex-column addressCheckOut w-100">
                {address.length > 0 ? (
                  <h5 className="text-black-50">Saved Addresses</h5>
                ) : (
                  <h5 className="text-black-50">
                    {readonly ? "No addresses saved" : "Enter New Address"}
                  </h5>
                )}

                <div className="AddressCard">
                  <div className="scrollable-addresses">
                    <div
                      className="scrollable-container"
                      style={{ maxHeight: "300px", overflowY: "auto" }}
                    >
                      {address.length === 0 && readonly ? (
                        <p className="text-muted ps-2 mb-0">— None —</p>
                      ) : (
                        address.map((addr) => (
                          <div
                            key={addr.id}
                            className={`checkOutCard m-2 d-flex ${
                              readonly ? "readonly-address" : ""
                            }`}
                            style={{
                              border:
                                !readonly && selectedAddressId === addr.id
                                  ? "2px solid black"
                                  : "1px solid #e9ecef",
                              cursor: readonly ? "default" : "pointer",
                              pointerEvents: readonly ? "none" : "auto",
                              opacity: readonly ? 0.9 : 1,
                            }}
                            onClick={
                              readonly
                                ? undefined
                                : () => {
                                    handleAddressSelect?.(addr.id);
                                    changeDeliveryAddress?.(addr);
                                  }
                            }
                          >
                            <div className="me-2">
                              <img
                                src={locationIcon}
                                alt="Location"
                                style={{ width: "1.5rem" }}
                              />
                            </div>
                            <div className="flex-grow-1 ps-1">
                              <h6 className="mb-1">{addr.address}</h6>
                              <div className="mb-1">
                                <Badge pill bg="info">
                                  {addr.tag}
                                </Badge>
                              </div>
                              {addr.noteForDeliveryMan && (
                                <p className="mb-0 text-muted small">
                                  Note: {addr.noteForDeliveryMan}
                                </p>
                              )}
                            </div>

                            {/* Action buttons — only if NOT readonly */}
                            {!readonly && (
                              <div
                                className="d-flex flex-row gap-2 ms-auto"
                                onClick={(e) => e.stopPropagation()}
                              >
                                <div
                                  onClick={() => handleCloseUpdateModal?.(addr)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <img
                                    src={EditIcon}
                                    alt="Edit"
                                    style={{ width: "1.4rem" }}
                                  />
                                </div>
                                <div
                                  onClick={() => handleDeleteAddress?.(addr.id)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <img
                                    src={DeleteIcon}
                                    alt="Delete"
                                    style={{ width: "1.5rem" }}
                                  />
                                </div>
                                {!addr.isDefault && (
                                  <Dropdown>
                                    <Dropdown.Toggle
                                      variant="link"
                                      id="dropdown-address-actions"
                                      className="p-0"
                                    >
                                      <div className="dot"></div>
                                      <div className="dot"></div>
                                      <div className="dot"></div>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      <Dropdown.Item
                                        onClick={() =>
                                          handleUpdateDefaultAddress?.(
                                            addr.id,
                                            addr.userId
                                          )
                                        }
                                      >
                                        Set as default
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                )}
                              </div>
                            )}
                          </div>
                        ))
                      )}

                      {/* Only show error in interactive mode */}
                      {!readonly && showAddressError && (
                        <p className="text-danger ps-2 pt-2 mb-0">
                          Please select or provide an address
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeliveryAddressCard;
